import React from 'react'
import logger from '../../../../utils/logger'

export const CustomInputSearch = ({ register, name, type, placeholder, className, blockEnter = false, }) => {

  logger.debug('register,name,type,placeholder: ', register, name, type, placeholder)

  return (
    <div className="form-floating form-aSearch">
      <input
        {...register(`${name}`)}
        id={name}
        type={type}
        className={`form-control input-height ${className}`}
        // className="form-control input-height"
        placeholder={placeholder}
        autoComplete={name}
        onKeyDown={(e) => {
          if (blockEnter && e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
          }
        }}
      />

      <label className="label-fButtons" htmlFor={name}>{placeholder}</label>

    </div>
  )
}
